<template>
    <section>
      <section class="grid-flex column">
        <!-- filters -->
        <div class="flex-1 w100">
          <div class="flex">
            <tabs :data="configTabs" v-model="currentTab"></tabs>
          </div>
        </div>
      </section>
      <section class="margin-top-m">
        <!-- account -->
        <account v-if="currentTab === 'account'"></account>
        <!-- integration -->
        <integration v-if="currentTab === 'integracoes'"></integration>
        <!-- imports -->
        <imports v-if="currentTab === 'imports'"></imports>
        <!-- users -->
        <user v-if="currentTab === 'user'"></user>
        <!-- project -->
        <project v-if="currentTab === 'project'"></project>
      </section>
    </section>
  </template>
  
  <script>
  import Tabs from "@/components/tabs/Tabs";
  import { mapState } from "vuex";

  import integration from "./Integration";
  import Account from "./Account";
  import User from "./User";
  import Project from "./Project";
  import Imports from "./Imports";
  
  export default {
    name: "config",
    components: {
      Tabs,
      Account,
      User,
      integration,
      Project,
      Imports
    },
    props: ['slug'],
    data() {
      return {
        loading: false,
        currentTab: "account",
      };
    },
    mounted() {
      if (this.slug) {
        this.currentTab = this.slug
      }
    },
    computed: {
      ...mapState({
        user: (state) => state.user,
        account: (state) => state.account,
      }),
      configTabs() {
      if (this.account.account_type === 'MANAGER') {
        return [
          {
            name: "account",
            title: "Conta",
          },
          {
            name: "integracoes",
            title: "Integrações",
          },
          {
            name: "imports",
            title: "Importações",
          },
          {
            name: "user",
            title: "Equipe (Usuários)",
          },
          {
            name: "project",
            title: "Projetos (Clientes)",
          },
        ]
      } else {
        return [
          {
            name: "account",
            title: "Conta",
          },
          {
            name: "integracoes",
            title: "Integrações",
          },
          {
            name: "imports",
            title: "Importações",
          },
          {
            name: "user",
            title: "Equipe (Usuários)",
          },
        ]
      }
      },
    },
    watch: {
      slug() {
        if (this.slug) {
          this.currentTab = this.slug
        } 
      },
      currentTab() {
        if (this.slug === this.currentTab) {
          return
        }
        this.$router.push({ name: "Config", params: { slug: this.currentTab } });
      }
    }
  
  };
  </script>
  
  <style lang="scss" scoped></style>
  